var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcZaperonLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 35.526,
    viewBox: "0 0 150 35.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4eb757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4ebd92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#4ec2bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4ec5da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ec6e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3659a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#4679bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#5394cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#589ed6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fc4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804a9c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_zaperon_logo_white",
    transform: "translate(-24 -137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8403",
    "data-name": "Path 8403",
    d: "M59.861,139.439v8.075a2.422,2.422,0,0,1-.35,1.067v-.241a6.447,6.447,0,0,0-6.447-6.447,4.394,4.394,0,0,0-.559.024,2.542,2.542,0,0,0-.367-.032h-20.8a2.445,2.445,0,0,0-2.449,2.414v4.922a2.445,2.445,0,0,1-2.351,2.442h-.183A2.444,2.444,0,0,1,24,149.221v-9.78A2.447,2.447,0,0,1,26.444,137h31a2.449,2.449,0,0,1,2.414,2.444Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8404",
    "data-name": "Path 8404",
    d: "M59.516,174.523v.24a2.391,2.391,0,0,1-.358.455,2.448,2.448,0,0,1-.668.471l-.109.049h-.008l-3.4,1.508-1.313.583-4.333,1.922-2.994,1.325-4.412,1.958-6.342,2.816h0a5.4,5.4,0,0,0-.539,10.03l-6.161-2.726-3.361-1.492h-.008l-.15-.066h0A2.432,2.432,0,0,1,24,189.4v-2.172A2.431,2.431,0,0,1,25.26,185.1h0l.356-.157h0l3.268-1.451,5.434-2.412,7.328-3.247.2-.086.085-.039,4.784-2.122,6.3-2.8h.013l.158-.071h0a2.435,2.435,0,0,0-.687-4.589c.184-.016.37-.024.559-.024a6.437,6.437,0,0,1,6.459,6.423Z",
    transform: "translate(0 -26.2)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8405",
    "data-name": "Path 8405",
    d: "M102.022,253.184v5.91a2.45,2.45,0,0,1-1.355,2.187h0l-.189.085-3.343,1.487L90.1,265.986l-4.943,2.206c-.043.02-.087.041-.131.058a2.441,2.441,0,0,1-1.88,0c-.038-.016-.076-.033-.112-.052l-4.951-2.206-.722-.315c-.052-.022-.1-.044-.158-.069a5.423,5.423,0,0,1,.537-10.068l-.484.216h0c-.044.017-.088.038-.131.058h0a2.446,2.446,0,0,0,0,4.4h.011a1.462,1.462,0,0,0,.135.06h0l5.74,2.554h0l.194.087a2.438,2.438,0,0,0,.895.17,1.578,1.578,0,0,0,.243-.013,2.4,2.4,0,0,0,.63-.15h0l.232-.1h0l10.357-4.612h.014l.206-.09h.009a2.386,2.386,0,0,0,.63-.455,2.431,2.431,0,0,0,.717-1.733v-2.745a2.444,2.444,0,0,1,2.381-2.444h.126a2.447,2.447,0,0,1,2.382,2.444Z",
    transform: "translate(-42.161 -95.912)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8406",
    "data-name": "Path 8406",
    d: "M284.65,215.425c0-.238-.008-.473-.008-.722V207.3a5.63,5.63,0,0,0-2.048-4.673A8.647,8.647,0,0,0,277.038,201a12.673,12.673,0,0,0-3.67.5,15.126,15.126,0,0,0-3.054,1.3l.069,4.667h3.487l.381-2.374a3.966,3.966,0,0,1,1.12-.539,4.76,4.76,0,0,1,1.4-.192,2.97,2.97,0,0,1,2.267.805,2.929,2.929,0,0,1,.755,2.1v1.328H277.42a11.841,11.841,0,0,0-4.44.731,6.053,6.053,0,0,0-2.723,2.009,4.946,4.946,0,0,0-.922,2.972,5.028,5.028,0,0,0,1.576,3.909,6.066,6.066,0,0,0,4.254,1.435,5.535,5.535,0,0,0,2.748-.655,6.816,6.816,0,0,0,2.031-1.76,6.245,6.245,0,0,0,.265,1.064c.123.354.244.685.366,1h6.009v-2.9l-1.875-.258A5.408,5.408,0,0,1,284.65,215.425Zm-4.856-1.037a3.562,3.562,0,0,1-1.418,1.2,4.255,4.255,0,0,1-1.925.455,2.5,2.5,0,0,1-1.684-.522,1.836,1.836,0,0,1-.6-1.486,2.272,2.272,0,0,1,.822-1.76,3.523,3.523,0,0,1,2.415-.731h2.39Z",
    transform: "translate(-206.679 -53.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8407",
    "data-name": "Path 8407",
    d: "M403.055,202.147a5.9,5.9,0,0,0-3.718-1.188,5.431,5.431,0,0,0-2.69.63,5.7,5.7,0,0,0-1.925,1.791l-.232-2.091h-7.04v2.921l2.59.5v18.032l-2.346.5v2.921h9.517v-2.921l-2.34-.5v-5.2a5.118,5.118,0,0,0,1.891,1.535,5.87,5.87,0,0,0,2.548.523,6.3,6.3,0,0,0,3.744-1.1,6.916,6.916,0,0,0,2.374-3.088,12.069,12.069,0,0,0,.821-4.64v-.35a13.758,13.758,0,0,0-.821-4.965A7.337,7.337,0,0,0,403.055,202.147Zm-1.653,8.623a7.13,7.13,0,0,1-.84,3.736,2.934,2.934,0,0,1-2.7,1.377,3.763,3.763,0,0,1-1.784-.4,2.994,2.994,0,0,1-1.2-1.161v-7.869a3.233,3.233,0,0,1,1.2-1.279,3.372,3.372,0,0,1,1.75-.447,2.87,2.87,0,0,1,2.017.722,4.307,4.307,0,0,1,1.171,1.992,10.378,10.378,0,0,1,.383,2.976Z",
    transform: "translate(-306.184 -53.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8408",
    "data-name": "Path 8408",
    d: "M534.429,201.932a8.048,8.048,0,0,0-4.1-.963,7.581,7.581,0,0,0-4.292,1.171,7.887,7.887,0,0,0-2.814,3.254,10.828,10.828,0,0,0-1,4.74v.665a9.573,9.573,0,0,0,1.054,4.547,7.794,7.794,0,0,0,2.98,3.129,8.663,8.663,0,0,0,4.5,1.138,11.674,11.674,0,0,0,3.86-.589,9.276,9.276,0,0,0,2.8-1.486l-1.311-2.994a9.5,9.5,0,0,1-2.255,1.01,8.731,8.731,0,0,1-2.482.34,4.255,4.255,0,0,1-2.174-.523,3.6,3.6,0,0,1-1.387-1.443,5.4,5.4,0,0,1-.589-2.1l.033-.1h10.557v-2.641a10.114,10.114,0,0,0-.863-4.382A6.209,6.209,0,0,0,534.429,201.932Zm-1.146,6.591H527.3l-.049-.083a7.29,7.29,0,0,1,.506-1.992,3.35,3.35,0,0,1,1.038-1.387,2.6,2.6,0,0,1,1.626-.506,2.894,2.894,0,0,1,1.653.432,2.453,2.453,0,0,1,.93,1.22,5.5,5.5,0,0,1,.29,1.891Z",
    transform: "translate(-419.727 -53.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8409",
    "data-name": "Path 8409",
    d: "M647.381,200.994a3.751,3.751,0,0,0-2.341.747,5.647,5.647,0,0,0-1.643,2.206l-.033-.4-.183-2.225h-7.09v2.921l2.574.5v11.14l-2.324.5v2.905h9.5v-2.907l-2.324-.5v-8.8a3.79,3.79,0,0,1,1.138-1.145,2.84,2.84,0,0,1,1.669-.348l2.406.132.515-4.465a6.683,6.683,0,0,0-.912-.191A6.557,6.557,0,0,0,647.381,200.994Z",
    transform: "translate(-515.647 -53.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8410",
    "data-name": "Path 8410",
    d: "M740.037,202.141a9.423,9.423,0,0,0-9.1,0,7.678,7.678,0,0,0-2.921,3.246A10.527,10.527,0,0,0,727,210.113v.348a10.667,10.667,0,0,0,1.013,4.755,7.607,7.607,0,0,0,2.926,3.235,8.648,8.648,0,0,0,4.569,1.161,8.412,8.412,0,0,0,4.532-1.161,7.653,7.653,0,0,0,2.906-3.23,10.7,10.7,0,0,0,1.013-4.755v-.353a10.628,10.628,0,0,0-1.013-4.749,7.721,7.721,0,0,0-2.909-3.224Zm-.9,8.326a9.54,9.54,0,0,1-.383,2.847,3.989,3.989,0,0,1-1.193,1.9,3.022,3.022,0,0,1-2.048.681,3.22,3.22,0,0,1-2.092-.673,3.827,3.827,0,0,1-1.186-1.9,9.847,9.847,0,0,1-.373-2.855v-.353a9.624,9.624,0,0,1,.373-2.814,3.939,3.939,0,0,1,1.186-1.91,3.459,3.459,0,0,1,4.142,0,4.02,4.02,0,0,1,1.186,1.91,9.4,9.4,0,0,1,.388,2.814Z",
    transform: "translate(-592.233 -53.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8411",
    "data-name": "Path 8411",
    d: "M863.789,215.881v-7.818q0-3.654-1.511-5.357a5.325,5.325,0,0,0-4.183-1.711,5.907,5.907,0,0,0-3.011.759,6.528,6.528,0,0,0-2.217,2.141l-.216-2.573h-7.09v2.921l2.573.5v11.14l-2.324.5v2.905h9.139v-2.905l-1.959-.5v-9.429a3.66,3.66,0,0,1,1.286-1.261,3.623,3.623,0,0,1,1.818-.44,2.778,2.778,0,0,1,2.126.755,3.732,3.732,0,0,1,.706,2.578v7.8l-2.075.5v2.905h9.263v-2.912Z",
    transform: "translate(-692.112 -53.965)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZaperonLogoWhite);
export default __webpack_public_path__ + "static/media/ic_zaperon_logo_white.d546c11182cdafd0cb1f8180e47ac844.svg";
export { ForwardRef as ReactComponent };